import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-app-batch-funding-need-bar-chart',
  templateUrl: './app-batch-funding-need-bar-chart.component.html',
  styleUrls: ['./app-batch-funding-need-bar-chart.component.scss']
})
export class AppBatchFundingNeedBarChartComponent implements OnInit {

  private _fundingNeedBarData: any;
  get fundingNeedBarData() {
    return this._fundingNeedBarData;
  }

  @Input() set fundingNeedBarData(val: any) {
    this._fundingNeedBarData = val;
    if (val) {
      this.appForFundingNeed = {
        series: this._fundingNeedBarData.series,
        chart: {
          type: "bar",
          animations: {
            speed: 400,
            animateGradually: {
              enabled: false
            }
          },
          fontFamily: 'inherit',
          foreColor: 'inherit',
          width: '100%',
          height: '100%',
          stacked: true,
          toolbar: {
            show: true
          },
          stackType: "100%"
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        xaxis: {
          categories: this._fundingNeedBarData.categories
        },
        tooltip: {
          // y: {
          //     formatter: function (val) {
          //         return val + "K";
          //     }
          // }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          offsetX: 40
        }
      };


    }
  }


  appForFundingNeed: any;

  constructor() { }

  ngOnInit(): void {

  }

}
